import {
  Applicant,
  convertFormDataToApplicant,
  convertFormDataToApplicantWithApplicantSchemaKeys,
  convertToFilteredDocument,
} from "./applicant";
import { FormData, RefKeyValueRegistry } from "@graffer-inc/form-schema";
import {
  AttachFileWithURL,
  ModifiedFile,
  ModifiedMyNumber,
  MyNumberWithID,
} from "./application-entity";
import type { ApplicantSchemaKeys } from "../procedure/procedure-detail";

export type ApplicationContentType = {
  readonly jsonDocument: FormData;
  files: Array<AttachFileWithURL>;
  myNumbers?: MyNumberWithID[];
  modifiedAt?: Date;
};

export type ModifiedApplicationContentType = {
  jsonDocument: FormData;
  files: ModifiedFile[];
  myNumbers?: ModifiedMyNumber[];
};

export class ApplicationContent {
  readonly jsonDocument: FormData;
  files: Array<AttachFileWithURL>;
  myNumbers?: MyNumberWithID[];
  modifiedAt?: Date;

  constructor(values: ApplicationContentType) {
    this.files = values.files;
    this.myNumbers = values.myNumbers;
    this.jsonDocument = values.jsonDocument;
    this.modifiedAt = values.modifiedAt;
  }

  /**
   * @deprecated
   * use `getApplicant` instead
   */
  get applicant() {
    return convertFormDataToApplicant(this.jsonDocument);
  }

  getApplicant(applicantSchemaKeys: ApplicantSchemaKeys): Applicant {
    return convertFormDataToApplicantWithApplicantSchemaKeys(
      this.jsonDocument,
      applicantSchemaKeys,
    );
  }

  get rawDocument() {
    return this.jsonDocument;
  }

  /**
   * @deprecated
   * ApplicationEntity.document からのみ参照される。
   * 過去の個別プランでの利用のみを前提としている。
   * 利用範囲を増やさないこと。
   */
  get filteredDocument() {
    return convertToFilteredDocument(this.jsonDocument);
  }

  get refKeys() {
    return Object.keys(this.refkeyValueRegistry);
  }

  get refkeyValueRegistry(): RefKeyValueRegistry {
    const result: RefKeyValueRegistry = {};
    this.files.forEach((f) => {
      if (f.refKey) {
        result[f.refKey] = f;
      }
    });
    this.myNumbers?.forEach((m) => {
      result[m.refKey] = {
        value: "",
        // この段階は申請が完了していてマイナンバーは検証済みなので、エラーを出さない
        skipValidate: true,
      };
    });
    return result;
  }
}
